import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ViewQuestionsModal } from "./ViewQuestionsModal";
import { resolveGroupCardTitle } from "utils/groupCardTitle";
import { request } from "hooks/useOkoApi/useOkoApi";
import { constants, logEducatorDashboard, LogLevel } from "utils";

// What a quick group's preview link opens.
export const quickGroupPreviewTarget = (qg) => ({
  id: qg.id,
  code: qg.standard_code,
  name: qg.standard_name,
  questionFilter: qg.question_filter || null,
  questionSetId: qg.question_set_id || null,
  groupCode: qg.code,
  // A quick group is a bare standard: no bundle, so no track tag.
  focus: resolveGroupCardTitle(qg, {}),
});

// Same editable preview the bundle cards open. A quick group's filter and set
// pointer live on the group row, so the filter Save goes to the quick-group
// PATCH rather than the bundle delta; the set itself is created on the shared
// question-sets endpoint, which now resolves quick groups.
export const QuickGroupQuestionsModal = ({ target, classroomId, onClose, onChanged }) => {
  const history = useHistory();
  const [savingFilter, setSavingFilter] = useState(false);
  const [filterSaveError, setFilterSaveError] = useState(null);
  return (
    <ViewQuestionsModal
      isOpen={Boolean(target)}
      onClose={() => { onClose(); setFilterSaveError(null); }}
      standardCode={target?.code}
      standardName={target?.name}
      questionFilter={target?.questionFilter}
      questionSetId={target?.questionSetId}
      groupCode={target?.groupCode}
      focus={target?.focus}
      editable
      onCreateQuestionSet={() => {
        if (!target?.groupCode) return;
        onClose();
        const params = new URLSearchParams({
          classroomId: classroomId || "",
          classId: classroomId || "",
          groupCode: target.groupCode,
        });
        history.push(`${constants.QUESTION_SET_PATH}?${params.toString()}`);
      }}
      saving={savingFilter}
      saveError={filterSaveError}
      onSave={async (nextQuestionFilter) => {
        if (!target?.id || !classroomId) return;
        setSavingFilter(true);
        setFilterSaveError(null);
        try {
          // Explicit set: the key is always present here, so null clears the
          // group's filter and an object replaces it.
          await request(`quick-groups/classrooms/${classroomId}/${target.id}`, {
            method: "PATCH",
            payload: { question_filter: nextQuestionFilter },
          });
          await onChanged?.();
          onClose();
        } catch (e) {
          logEducatorDashboard("QuickGroupsSection: failed to save question filter", {
            level: LogLevel.WARNING,
            event: "quick_group_filter_save_error",
            statusCode: e?.status,
            quickGroupId: target.id,
          });
          setFilterSaveError(e?.detail || e?.message || "Failed to save filters.");
        } finally {
          setSavingFilter(false);
        }
      }}
    />
  );
};
